module.exports = __webpack_public_path__ + "static/media/boxed-bg.1fa5de4f.png";